// src/hooks/useLogout.ts
import { useNavigate } from 'react-router-dom';
import { useDialog } from '../dialog/DialogProvider';
import OneButtonAlertDialog from '../dialog/OneButtonAlertDialog';
import useMember from './useMember';
import MemberAPI from '../apis/MemberAPI';

export default function useLogout() {
  const { logout } = useMember();     
  const navigate = useNavigate();
  const { showDialog } = useDialog();

  return async function logout2() {
    try {
      await MemberAPI.logout();  
      logout();                   
    } catch (e) {
      console.warn('API 로그아웃 실패, 클라이언트만 초기화합니다.', e);
    }
    navigate('/');
    showDialog(OneButtonAlertDialog, {
      message: '로그아웃 되었습니다.',
      title: '',
      onClose: () => window.location.reload(),
    });
  };
}
